import AxiosInterceptor from 'api/interceptor';

const partner = new AxiosInterceptor();

export default {
    getList(){
        return partner.get('/site/partners');
    },
    uploadFile(file){
        let formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'sliders');
        return partner.post('/media/upload',formData);
    },
    addPartner(slide){
        return partner.post('/site/partners',slide);
    },
    getPartner(id){
        return partner.get('/site/partners/'+id);
    },
    updatePartner(params){
        return partner.put('/site/partners/'+params.id,params);
    },
    removePartner(id){
        return partner.delete('/site/partners/'+id);
    },
    saveList(list){
        return partner.put('/site/partners/save',{list: list});
    }
};